export default __webpack_public_path__ + "static/media/fantom.e842aa42.svg";